'use strict'

import css from './service-selection.styles.scss'
import template from './service-selection.template.pug'

class ServiceSelectionController {
  $onChanges() {
    if (this.lines.length === 1) {
      this.line = this.lines[0]
      this.select()
    }
  }

  select() {
    if (this.line) {
      this.onSelect({ lineNo: this.line.lineNo })
    }
  }
}

export const umsServiceSelection = {
  controller: ServiceSelectionController,
  template: template({ css }),
  bindings: {
    lines: '<',
    onSelect: '&',
    quantity: '=',
  },
}



// WEBPACK FOOTER //
// ./app/orders/components/service-selection/service-selection.component.js